enum GarminConnectionStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  DELETED = 'DELETED',
  DEREGISTERED = 'DEREGISTERED'
}

interface GarminConnectionModel {
  id: number;
  name: string;
  createdAt: string;
  status: GarminConnectionStatus;
  permissions: string[];
  userId: number;
}

export { GarminConnectionStatus };
export type { GarminConnectionModel };
